import { render, staticRenderFns } from "./OveralTest.vue?vue&type=template&id=6e3c7462&scoped=true"
import script from "./OveralTest.vue?vue&type=script&lang=js"
export * from "./OveralTest.vue?vue&type=script&lang=js"
import style0 from "./OveralTest.vue?vue&type=style&index=0&id=6e3c7462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c7462",
  null
  
)

export default component.exports